import React from 'react'
import Card from '../../shared/layout/card/Card';
import classes from './imagesplash.module.scss';
function ImageSplashTwo() {
  return (
    <Card className={classes['cargo-image2']}></Card>
  )
}

export default ImageSplashTwo;